'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useI18n, Language } from '@udemy-v2/i18n';
import { Icon } from '@udemy-v2/icons';
import styles from './course-language.module.scss';
import classNames from 'classnames';
export interface CourseLanguagesProps {
  courseLocale?: string;
}

/**
 * CourseLanguages displays the primary language of the course
 */
export const CourseLanguage: React.FC<CourseLanguagesProps> = t0 => {
  const $ = _c(10);
  const {
    courseLocale
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles["course-languages"], "ud-text-sm");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== gettext) {
    t2 = gettext("Course Language");
    $[1] = gettext;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Icon glyph="language" size="xsmall" color="subdued-inverted" label={false} role="img" aria-label={t2} aria-hidden={false} />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = courseLocale ?? "";
  let t5;
  if ($[5] !== t4) {
    t5 = <span><Language locale={t4} /></span>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <div className={t1} data-purpose="course-language">{t3}{t5}</div>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};